export enum PedestalTypeEnum {
  Concrete = 0,
  Plastic = 1,
}
